export default __webpack_public_path__ + "static/media/flag.ee26f64c.svg";